import { MdFormatListNumbered } from 'react-icons/md'
import { TbBuildingWarehouse, TbTruckDelivery } from 'react-icons/tb'
import { BsBox } from 'react-icons/bs'
import { LiaStoreSolid } from 'react-icons/lia'

import { IoBagHandleOutline } from 'react-icons/io5'
import { PiFactory, PiNewspaperClippingLight } from 'react-icons/pi'
import { RiFileList2Line } from 'react-icons/ri'
import { ReactElement } from 'react'
import { FiCreditCard } from 'react-icons/fi'

export const SIDEBAR_ICONS: Record<string, ReactElement> = {
  finance: <FiCreditCard size={24} />,
  orders: <MdFormatListNumbered size={24} />,
  list_alt: <BsBox size={24} />,
  stores: <LiaStoreSolid size={24} />,
  warehouse: <TbBuildingWarehouse size={24} />,
  delivery: <TbTruckDelivery size={24} />,
  marketing: <IoBagHandleOutline size={24} />,
  blog: <PiNewspaperClippingLight size={24} />,
  activity: <RiFileList2Line size={24} />,
  production: <PiFactory size={24} />,
}
